module.exports = __webpack_public_path__ + "static/media/fedpa-pin.6602d09d.svg";